import omit from 'lodash/omit';
import { EMPTY } from '../../constants/rowTypes';
import type { ReportRow } from '@common/xlsxExport/builders/reportBuilderTypes';

export const flattenChildrenTree = (reportRow: ReportRow) => {
  const _flatten = ({ children, expandable }: ReportRow, depth: number): Omit<ReportRow, 'children'>[] => {
    if (!children) {
      return [];
    }

    return children.reduce((rows, row) => [
      ...rows,
      {
        ...omit(row, ['children']),
        ...expandable
          ? {
            $style: {
              outlineLevel: depth + 1,
            },
          }
          : {},
      },
      ..._flatten(row, depth + 1),
    ], [] as Omit<ReportRow, 'children'>[]);
  };


  return [
    ..._flatten(reportRow, 0),
    ...reportRow.expandable
      ? [{
        $style: {
          outlineLevel: 1,
        },
        rowType: EMPTY,
      }]
      : [],
  ];
};
